import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AlertType} from "../../components/ui/Alert";

export interface IAlert {
    show: boolean,
    message: string,
    type: AlertType
}

export const initialState: IAlert = {
    show: false,
    message: '',
    type: AlertType.Notification
}

export const slice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        hideGlobalAlert(state) {
            state.show = false
        },
        clearGlobalAlert(state) {
            state.message = ''
            state.type = AlertType.Notification
        },
        setGlobalAlert(state, action: PayloadAction<{ message: string, type: AlertType }>) {
            state.type = action.payload.type
            state.message =  action.payload.message
            state.show = true
        },
    },
})

export const {
    setGlobalAlert,
    hideGlobalAlert,
    clearGlobalAlert
} = slice.actions;

export default slice.reducer;
